import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import "../css/reset.css";
import "../css/main.css";
import Hero from "../component/Hero";
import Service from "../component/Service";
import Service2 from "../component/Service2";
import Process from "../component/Process";
import Review from "../component/Review";
import About from "../component/About";
import Company from "../component/Company";
import MainPortfolio from "../component/MainPortfolio";
import MainContact from "../component/MainContact";

const Main = (prop) => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (location.hash) {
        const target = location.hash.substring(1);
        if (target) {
          scroller.scrollTo(target, {
            spy: true,
            smooth: true,
            offset: -100,
            duration: 500,
          });
        }
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <div className="app" id="appSection" name="appSection">
        <Hero />
        <div className="app_content">
          <Service />
          <Service2 />
          <Process />
          <MainPortfolio />
          <About />
          <Company />
          <Review />
          <MainContact />
        </div>
      </div>
    </>
  );
};

export default Main;
